export function flattenObject(
	nestedObject: Record<string, unknown>
): Record<string, unknown> {
	const plainObject: Record<string, unknown> = {}

	function flatten(object: Record<string, unknown>) {
		Object.keys(object).forEach((key) => {
			const value = object[key]
			if (typeof value === 'object' && value !== null) {
				flatten(value as Record<string, unknown>)
			} else {
				plainObject[key] = value
			}
		})
	}

	flatten(nestedObject)

	return plainObject
}
